// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VBlDIU8WvyYvSp1qquTg {
  position: relative;
  flex-grow: 1;
  background: white;
  padding: 60px 48px 24px 48px;
}
@media only screen and (max-width: 1419px) {
  .VBlDIU8WvyYvSp1qquTg {
    padding: 48px 0 0 48px;
  }
}
@media only screen and (max-width: 1023px) {
  .VBlDIU8WvyYvSp1qquTg {
    padding: 0;
  }
}

.NTMsmgpnhFDIpDHqpscl {
  position: absolute;
  top: 0;
  right: 0;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #EFEFEF;
}
@media only screen and (max-width: 1023px) {
  .NTMsmgpnhFDIpDHqpscl {
    top: -90px;
    background: #FCFCFC;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
  }
}
@media only screen and (max-width: 767px) {
  .NTMsmgpnhFDIpDHqpscl {
    top: -70px;
  }
}
.NTMsmgpnhFDIpDHqpscl svg {
  transition: transform 0.2s;
}
.dark-mode .NTMsmgpnhFDIpDHqpscl {
  background: #272B30;
}
.dark-mode .NTMsmgpnhFDIpDHqpscl svg {
  fill: #FCFCFC;
}

.NTMsmgpnhFDIpDHqpscl:hover svg {
  transform: rotate(90deg);
}

.JW2FXdOyK_OXIK_zBSZn,
.VGRGnJD7BSxnIhK0UYFd {
  margin-bottom: 48px;
}
@media only screen and (max-width: 1339px) {
  .JW2FXdOyK_OXIK_zBSZn,
  .VGRGnJD7BSxnIhK0UYFd {
    margin-bottom: 32px;
  }
}

.qG3vghf5bkg6BezUEFvi {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.7142857143;
  color: #1A1D1F;
  transition: color 0.2s;
}
.qG3vghf5bkg6BezUEFvi svg {
  margin-right: 12px;
  fill: #6F767E;
  transition: fill 0.2s;
}
.dark-mode .qG3vghf5bkg6BezUEFvi {
  color: #FCFCFC;
}

.qG3vghf5bkg6BezUEFvi:hover {
  color: #2A85FF;
}
.qG3vghf5bkg6BezUEFvi:hover svg {
  fill: #2A85FF;
}

.DkRUy00OWAPRB6nTYogU {
  display: flex;
  align-items: center;
  padding: 20px 0;
  border-width: 1px 0;
  border-style: solid;
  border-color: #EFEFEF;
}
@media only screen and (max-width: 767px) {
  .DkRUy00OWAPRB6nTYogU {
    padding: 16px 0;
  }
}
.dark-mode .DkRUy00OWAPRB6nTYogU {
  border-color: #272B30;
}

.Evqzpj_O9qaJI9uyRODg svg {
  fill: #6F767E;
  transition: fill 0.2s;
}
.Evqzpj_O9qaJI9uyRODg:hover svg {
  fill: #2A85FF;
}
.Evqzpj_O9qaJI9uyRODg:not(:last-child) {
  margin-right: 32px;
}

.qG3vghf5bkg6BezUEFvi:not(:last-child),
.DkRUy00OWAPRB6nTYogU:not(:last-child) {
  margin-bottom: 20px;
}
@media only screen and (max-width: 767px) {
  .qG3vghf5bkg6BezUEFvi:not(:last-child),
  .DkRUy00OWAPRB6nTYogU:not(:last-child) {
    margin-bottom: 16px;
  }
}

.u24z5mjrkWa_07D5Dg84 {
  margin-top: 48px;
}
@media only screen and (max-width: 1339px) {
  .u24z5mjrkWa_07D5Dg84 {
    margin-top: 32px;
  }
}

.lf30vz9X1V8hxCtkzrMw {
  max-width: 1200px;
  margin: -120px auto 0;
}
@media only screen and (max-width: 767px) {
  .lf30vz9X1V8hxCtkzrMw {
    margin-top: -188px;
  }
}

.LiCL2LmNC_vp6MOLkZXJ {
  display: flex;
  align-items: center;
  margin-bottom: 0px;
}
@media only screen and (max-width: 767px) {
  .LiCL2LmNC_vp6MOLkZXJ {
    flex-wrap: wrap;
  }
}

.bwjl5lNR6R3aux_Rmxd2 {
  display: flex;
  margin-right: auto;
}
@media only screen and (max-width: 767px) {
  .bwjl5lNR6R3aux_Rmxd2 {
    width: 100%;
    margin: 0 0 16px;
  }
}

.d4H17lu9yhXDGblQCKzk {
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.6;
  color: #6F767E;
  transition: all 0.2s;
}
@media only screen and (max-width: 767px) {
  .d4H17lu9yhXDGblQCKzk {
    flex-grow: 1;
  }
}
.d4H17lu9yhXDGblQCKzk:hover, .d4H17lu9yhXDGblQCKzk.Z_3PVw6VgAmtQJ8AxTqC {
  color: #1A1D1F;
}
.dark-mode .d4H17lu9yhXDGblQCKzk:hover, .dark-mode .d4H17lu9yhXDGblQCKzk.Z_3PVw6VgAmtQJ8AxTqC {
  color: #FCFCFC;
}

.d4H17lu9yhXDGblQCKzk.Z_3PVw6VgAmtQJ8AxTqC {
  background: #EFEFEF;
}
.dark-mode .d4H17lu9yhXDGblQCKzk.Z_3PVw6VgAmtQJ8AxTqC {
  background: #272B30;
}

.d4H17lu9yhXDGblQCKzk:not(:last-child) {
  margin-right: 8px;
}
@media only screen and (max-width: 767px) {
  .d4H17lu9yhXDGblQCKzk:not(:last-child) {
    margin-right: 0;
  }
}

@media only screen and (max-width: 767px) {
  .P5wRmQRCTbF33zpEu0__ {
    flex-grow: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/users/Details/Details.module.sass","webpack://./src/styles/helpers.sass"],"names":[],"mappings":"AAEA;EACI,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,4BAAA;AADJ;ACDI;EDFJ;IAMQ,sBAAA;EACN;AACF;ACGI;EDXJ;IAQQ,UAAA;EAIN;AACF;;AAHA;EACI,kBAAA;EACA,MAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBCwBC;ADlBL;ACZI;EDDJ;IASQ,UAAA;IACA,mBCmBH;IDlBG,2CAAA;EAQN;AACF;AChBI;EDJJ;IAaQ,UAAA;EAWN;AACF;AAXI;EACI,0BAAA;AAaR;ACoJa;ED/JL,mBCiBH;ADHL;AAbQ;EACI,aCUP;ADKL;;AAbQ;EACI,wBAAA;AAgBZ;;AAdA;;EAEI,mBAAA;AAiBJ;AChDI;ED6BJ;;IAIQ,mBAAA;EAoBN;AACF;;AAnBA;EACI,aAAA;EACA,mBAAA;EC4CA,eAAA;EACA,gBAAA;EACA,yBAAA;ED5CA,cCCC;EDAD,sBAAA;AAwBJ;AAvBI;EACI,kBAAA;EACA,aCNH;EDOG,qBAAA;AAyBR;ACgHa;EDvIL,cCZH;ADsCL;;AAzBI;EACI,cCzBH;ADqDL;AA3BQ;EACI,aC3BP;ADwDL;;AA3BA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,qBCtBC;ADoDL;AC/EI;ED2CJ;IAQQ,eAAA;EAgCN;AACF;ACwFa;EDvHL,qBCvBH;ADyDL;;AA/BI;EACI,aC7BH;ED8BG,qBAAA;AAkCR;AAhCQ;EACI,aC/CP;ADiFL;AAjCI;EACI,kBAAA;AAmCR;;AA/BI;;EACI,mBAAA;AAmCR;ACvGI;EDmEA;;IAGQ,mBAAA;EAsCV;AACF;;AArCA;EACI,gBAAA;AAwCJ;AC1HI;EDiFJ;IAGQ,gBAAA;EA0CN;AACF;;AAvCA;EACI,iBAAA;EACA,qBAAA;AA0CJ;AC3HI;ED+EJ;IAIQ,kBAAA;EA4CN;AACF;;AA3CA;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;AA8CJ;ACtII;EDqFJ;IAKQ,eAAA;EAgDN;AACF;;AA/CA;EACI,aAAA;EACA,kBAAA;AAkDJ;AChJI;ED4FJ;IAIQ,WAAA;IACA,gBAAA;EAoDN;AACF;;AAlDA;EACI,iBAAA;EACA,kBAAA;ECxCA,eAAA;EACA,gBAAA;EACA,gBAAA;EDwCA,cC5EC;ED6ED,oBAAA;AAuDJ;AChKI;EDoGJ;IAOQ,YAAA;EAyDN;AACF;AAzDI;EAEI,cC/EH;ADyIL;ACIa;ED5DD,cCvFP;ADkJL;;AA1DI;EACI,mBCvFH;ADoJL;ACHa;EDxDD,mBCtFP;ADoJL;;AA7DI;EACI,iBAAA;AAgER;ACtLI;EDqHA;IAGQ,eAAA;EAkEV;AACF;;AC3LI;ED0HJ;IAEQ,YAAA;EAoEN;AACF","sourcesContent":["@import ../../../styles/helpers\n\n.details\n    position: relative\n    flex-grow: 1\n    background: white\n    padding: 60px 48px 24px 48px\n    +w\n        padding: 48px 0 0 48px\n    +t\n        padding: 0\n\n.close\n    position: absolute\n    top: 0\n    right: 0\n    width: 36px\n    height: 36px\n    border-radius: 50%\n    background: $n3\n    +t\n        top: -90px\n        background: $n1\n        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05)\n    +m\n        top: -70px\n    svg\n        transition: transform .2s\n    +dark\n        background: $n6\n        svg\n            fill: $n1\n    &:hover\n        svg\n            transform: rotate(90deg)\n\n.head,\n.editor\n    margin-bottom: 48px\n    +x\n        margin-bottom: 32px\n\n.line\n    display: flex\n    align-items: center\n    +base2\n    color: $n7\n    transition: color .2s\n    svg\n        margin-right: 12px\n        fill: $n4\n        transition: fill .2s\n    +dark\n        color: $n1\n    &:hover\n        color: $p1\n        svg\n            fill: $p1\n\n.socials\n    display: flex\n    align-items: center\n    padding: 20px 0\n    border-width: 1px 0\n    border-style: solid\n    border-color: $n3\n    +m\n        padding: 16px 0\n    +dark\n        border-color: $n6\n\n.social\n    svg\n        fill: $n4\n        transition: fill .2s\n    &:hover\n        svg\n            fill: $p1\n    &:not(:last-child)\n        margin-right: 32px\n\n.line,\n.socials\n    &:not(:last-child)\n        margin-bottom: 20px\n        +m\n            margin-bottom: 16px\n\n.history\n    margin-top: 48px\n    +x\n        margin-top: 32px\n\n\n\n.card\n    max-width: 1200px\n    margin: -120px auto 0\n    +m\n        margin-top: -188px\n\n.control\n    display: flex\n    align-items: center\n    margin-bottom: 0px\n    +m\n        flex-wrap: wrap\n\n.nav\n    display: flex\n    margin-right: auto\n    +m\n        width: 100%\n        margin: 0 0 16px\n\n\n.link\n    padding: 8px 16px\n    border-radius: 8px\n    +base1-s\n    color: $n4\n    transition: all .2s\n    +m\n        flex-grow: 1\n    &:hover,\n    &.active\n        color: $n7\n        +dark\n            color: $n1\n    &.active\n        background: $n3\n        +dark\n            background: $n6\n    &:not(:last-child)\n        margin-right: 8px\n        +m\n            margin-right: 0\n\n.dropdownBox\n    +m\n        flex-grow: 1","@use \"sass:math\"\n\n// media queries\n=w\n    @media only screen and (max-width: \"1419px\")\n        @content\n=x\n    @media only screen and (max-width: \"1339px\")\n        @content\n=d\n    @media only screen and (max-width: \"1259px\")\n        @content\n=t\n    @media only screen and (max-width: \"1023px\")\n        @content\n=m\n    @media only screen and (max-width: \"767px\")\n        @content\n=a\n    @media only screen and (max-width: \"639px\")\n        @content\n=s\n    @media only screen and (max-width: \"474px\")\n        @content\n\n// fonts\n=inter\n    font-family: 'Inter', sans-serif\n\n// colors\n$p1: #2A85FF\n$p2: #83BF6E\n$p3: #FF6A55\n$p4: #8E59FF\n$s1: #FFBC99\n$s2: #CABDFF\n$s3: #B1E5FC\n$s4: #B5E4CA\n$s5: #FFD88D\n\n$n: #FFFFFF\n$n1: #FCFCFC\n$n2: #F4F4F4\n$n3: #EFEFEF\n$n4: #6F767E\n$n5: #33383F\n$n6: #272B30\n$n7: #1A1D1F\n$n8: #111315\n\n$shades1: #9A9FA5\n$shades2: #6F767E\n$shades3: rgba(#6F767E, .4)\n$shades4: rgba(#111315, .5)\n\n// typography\n=title1-s\n    font-size: 20px\n    font-weight: 600\n    line-height: math.div( 32 , 20 )\n    letter-spacing: -.02em\n    +m\n        font-size: 18px\n\n=title1-m\n    font-size: 20px\n    font-weight: 500\n    line-height: math.div(32,20)\n    letter-spacing: -.02em\n    +m\n        font-size: 18px\n\n=title2\n    font-size: 18px\n    line-height: math.div(24,18)\n    letter-spacing: -0.02em\n\n=base1-s\n    font-size: 15px\n    font-weight: 600\n    line-height: math.div(24,15)\n\n=base1-b\n    font-size: 15px\n    font-weight: 700\n    line-height: math.div(24,15)\n\n=base2\n    font-size: 14px\n    font-weight: 600\n    line-height: math.div(24,14)\n\n=body1-m\n    font-size: 15px\n    font-weight: 500\n    line-height: math.div(24,15)\n    letter-spacing: -.015em\n\n=body1-s\n    font-size: 15px\n    font-weight: 600\n    line-height: math.div(24,15)\n    letter-spacing: -.015em\n\n=body2-s\n    font-size: 14px\n    font-weight: 600\n    line-height: math.div(24,14)\n\n=caption1\n    font-size: 13px\n    font-weight: 600\n    line-height: math.div(16,13)\n\n=caption1-m\n    font-size: 13px\n    font-weight: 500\n    line-height: math.div(16,13)\n\n=caption2\n    font-size: 12px\n    font-weight: 700\n    line-height: math.div(16,12)\n\n=caption2-m\n    font-size: 12px\n    font-weight: 500\n    line-height: 1\n\n=button1\n    font-size: 15px\n    font-weight: 700\n    line-height: math.div(24,15)\n\n=button2\n    font-size: 13px\n    font-weight: 700\n    line-height: math.div(24,13)\n    \n//triangle\n=arr($width, $height, $bg, $direction)\n    width: 0px\n    height: 0px\n    border-style: solid\n    @if $direction == t\n        border-width: 0 $width / 2 + px $height + px $width / 2 + px\n        border-color: transparent transparent $bg transparent\n    @if $direction == r\n        border-width: $height / 2 + px 0 $height / 2 + px $width + px\n        border-color: transparent transparent transparent $bg\n    @if $direction == b\n        border-width: $height + px $width / 2 + px 0 $width / 2 + px\n        border-color: $bg transparent transparent transparent\n    @if $direction == l\n        border-width: $height / 2 + px $width + px $height / 2 + px 0\n        border-color: transparent $bg transparent transparent\n    @if $direction == tl\n        border-width: $height + px $width + px 0 0\n        border-color: $bg transparent transparent transparent\n    @if $direction == tr\n        border-width: 0 $width + px $height + px 0\n        border-color: transparent $bg transparent transparent\n    @if $direction == br\n        border-width: 0 0 $height + px $width + px\n        border-color: transparent transparent $bg transparent\n    @if $direction == bl\n        border-width: $width + px 0 0 $height + px\n        border-color: transparent transparent transparent $bg\n// example\n// +arr(500,50, #000, l)\n// +arr(500,50, #000, bl)\n\n// placeholder\n=placeholder\n    &::placeholder\n        @content\n\n// media query width\n=r($width)\n    @media only screen and (max-width: $width+ \"px\")\n        @content\n\n=rmin($width)\n    @media only screen and (min-width: $width+ \"px\")\n        @content\n\n// theme\n=dark\n    @at-root :global(.dark-mode) &\n        @content\n\n=dark-body\n    @at-root .dark-mode\n        @content\n\n=dark-common\n    @at-root .dark-mode &\n        @content"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"details": `VBlDIU8WvyYvSp1qquTg`,
	"close": `NTMsmgpnhFDIpDHqpscl`,
	"head": `JW2FXdOyK_OXIK_zBSZn`,
	"editor": `VGRGnJD7BSxnIhK0UYFd`,
	"line": `qG3vghf5bkg6BezUEFvi`,
	"socials": `DkRUy00OWAPRB6nTYogU`,
	"social": `Evqzpj_O9qaJI9uyRODg`,
	"history": `u24z5mjrkWa_07D5Dg84`,
	"card": `lf30vz9X1V8hxCtkzrMw`,
	"control": `LiCL2LmNC_vp6MOLkZXJ`,
	"nav": `bwjl5lNR6R3aux_Rmxd2`,
	"link": `d4H17lu9yhXDGblQCKzk`,
	"active": `Z_3PVw6VgAmtQJ8AxTqC`,
	"dropdownBox": `P5wRmQRCTbF33zpEu0__`
};
export default ___CSS_LOADER_EXPORT___;
